import React from 'react';
import ReactDOM from 'react-dom/client';
import {AuthProvider} from "./context/AuthProvider";
import {ShoppingCartProvider} from "./context/ShoppingCartContext";
import App from './App';
import {BrowserRouter, Route} from "react-router-dom";
import {Routes} from "react-router";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const root = ReactDOM.createRoot(window.document.getElementById('root'));
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <ShoppingCartProvider>
            <Routes>
              <Route path="/*" element={<App />} />
            </Routes>
          </ShoppingCartProvider>
        </QueryClientProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
